import { Component, ViewChild, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AdminAuthService } from './auth/admin-auth.service';
import * as version from '../../mif/environments/versions';

@Component({
  standalone: false,
  selector: 'app-root-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  constructor(private adminAuthService: AdminAuthService) {}

  @ViewChild('sidenav') sidenav: MatSidenav;
  isShowing = false;
  isLoggedIn: boolean;

  ngOnInit(): void {
    this.adminAuthService.isAuthenticated().subscribe(async isAuthenticated => {
      this.isLoggedIn = isAuthenticated;
    });
    console.log('version: ' + JSON.stringify(version));
  }

  mouseenter(): void {
    this.isShowing = true;
  }

  mouseleave(): void {
    this.isShowing = false;
  }

  isSidebarCollapsed = false;

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  menuItems: MenuItem[] = [
    {
      icon: 'dashboard',
      label: 'Accueil',
      link: 'home'
      // isOpen: false
      // children: [
      //   { icon: 'fas fa-chart-pie', label: 'Analytics' },
      //   { icon: 'fas fa-tasks', label: 'Projects' }
      // ]
    },
    {
      icon: 'list_alt',
      label: 'Libellés',
      link: 'labels'
    },
    {
      icon: 'local_offer',
      label: 'Offres promotionnelles',
      link: 'offers'
    },
    {
      icon: 'notifications',
      label: 'Notifications email',
      link: 'emails'
    },
    {
      icon: 'settings',
      label: 'Paramètres',
      link: 'settings'
    },
    {
      icon: 'subject',
      label: 'Offre GPA',
      link: 'gpa-in-cems'
    },
    {
      icon: 'assessment',
      label: 'Performance passée',
      link: 'performance'
    },
    {
      icon: 'cancel_presentation',
      label: 'Abandons de souscription',
      link: 'subscription-abandonments'
    },
    {
      icon: 'exit_to_app',
      label: 'Se déconnecter',
      link: '/authentication/logout'
    }
  ];

  toggleSidebar() {
    this.onSidebarToggle();
  }

  toggleMenuItem(item: MenuItem) {
    // Only toggle if sidebar is not collapsed and item has children
    if (!this.isSidebarCollapsed && item.children) {
      item.isOpen = !item.isOpen;
    }
  }
}

interface MenuItem {
  icon: string;
  link: string;
  label: string;
  children?: MenuItem[];
  isOpen?: boolean;
}
